export default "__VITE_ASSET__IVZTvVia__"